import {defineStore} from "pinia";
import {ILesson} from "@/types/api.ts";

export const useCommonStore = defineStore("common-store", {
    state: () => ({
        lesson: null as ILesson | null,
    }),
    actions: {
        setLesson(value: ILesson | null) {
            this.lesson = value;
        }
    },
    getters: {
        getCurrentLesson(): ILesson | null {
            return this.lesson;
        }
    }
})